// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3JgTt","inner":"Form_inner__o_lj6","range":"Form_range__kzHt9","name":"Form_name__woe0G","actions":"Form_actions__3RAz1"};